import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';

import { JobStatusEnum } from '../job/useJob';
import { contentDeploymentKeys } from './keys';
import { TContentRefreshHistoryResponse } from './types';

const POLL_INTERVAL_MS = 5_000;

const IN_FLIGHT_STATUSES = new Set<JobStatusEnum>([
  JobStatusEnum.NOT_STARTED,
  JobStatusEnum.RUNNING,
]);

export function useContentRefreshHistory() {
  return useQuery({
    queryKey: contentDeploymentKeys.FETCH_REFRESH_HISTORY(),
    queryFn: async (): Promise<TContentRefreshHistoryResponse> => {
      const response = await fetcher('content-deployment/history', {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error('Failed to fetch the content refresh history.');
      }
      return response.json();
    },
    refetchInterval: (query) => {
      const hasInFlightJob = (query.state.data?.history ?? []).some((item) =>
        IN_FLIGHT_STATUSES.has(item.status)
      );
      return hasInFlightJob ? POLL_INTERVAL_MS : false;
    },
  });
}
